import React from "react";
import { Link, useLocation } from "react-router-dom";

const CustomError = () => {
    const location = useLocation();
    const { state } = location;
    const error = state && state.error;

    const defaultMessage = {
        message: "Page not found",
        url: "/",
    };

    const displayError = error || defaultMessage;

    return (
        <div className="fix-wrapper">
            <div className="container mt-4">
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="form-input-content text-center error-page">
                            <h1 className="error-text fw-bold text-danger mb-3">{displayError.message}</h1>
                            <h4>
                                <i className="fa fa-exclamation-triangle text-warning" />{" "}
                                The page <br /> <span className="fw-bold">{displayError.url}</span> <br /> you were looking for is not found!
                            </h4>
                            <p>
                                You may have mistyped the address or the page may have moved.
                            </p>
                            <div>
                                <Link className="btn btn-primary" to="/">
                                    Back to Home
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomError;
